<template>
    <div>
        <Forms
            ref="frmCommissons"
            :title="'Filtro de Comissões'"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            :dontShowFooter="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
        >
            <div class="container-folders">
                <!-- <FilterGroupPaste
                    v-for="folder in DataFolder"
                    :key="folder.empreendimentoId"
                    :id="folder.empreendimentoId"
                    :accordion="'level-1'"
                    :title="folder.empreendimentoNome"
                    v-on:selectFilterParam="selectFilterParam('selectedEnterprise', folder.empreendimentoId)"
                >
                    <FilterGroupPaste
                        v-for="accredited in folder.credenciadas"
                        :key="accredited.credenciadaId"
                        :id="`${accredited.credenciadaId}_${folder.empreendimentoId}`"
                        :accordion="'level-2'"
                        :ref="`accredited`"
                        :title="accredited.credenciadaNome"
                        v-on:selectFilterParam="selectFilterParam('selectedAccredited', accredited.credenciadaId)"
                        class="identy-1 folder-item"
                    >
                        <div
                            v-for="realtor in accredited.corretores"
                            :key="realtor.contaId"
                            :id="`${realtor.contaId}_${accredited.credenciadaId}`"
                            :value="realtor.contaId"
                            class="realtor-name identy-2 folder-item"
                            v-on:click="selectFilterParam('selectedRealtor', realtor.contaId)"
                        >
                            {{realtor.corretorNome}}
                        </div>
                    </FilterGroupPaste>
                </FilterGroupPaste> -->

            <div id="form-search">
              <div class="margem">
                <label class="labelseach">Imobiliária</label>
                    <autocomplete-z ref="ImobliariaTypeahead"
                          placeholder="Digite uma imobiliária"
                          iconClass="fas fa-sign"
                          :serializer="(Imobiliaria) => Imobiliaria.nome"
                          :debounceLength="3"
                          :formField="SearchItems.imobiliariaObj"
                          v-on:search="onSearchImobliaria"
                          v-on:changeCode="onSearchImobliaria"
                          :ShowCode="false"
                           />
              </div>
              <div class="margem">
                <label class="labelseach">Corretor</label>
                <autocomplete-z ref="ClienteTypeahead"
                            placeholder="Digite um corretor"
                            iconClass="fas fa-user"
                            :serializer="(corretor) => corretor.nome"
                            :debounceLength="2"
                            :formField="SearchItems.corretor"
                            v-on:search="onSearchUsuario"
                            v-on:changeCode="onSearchUsuario"
                            :ShowCode="false"
                            />
              </div>
              <div class="margem">
                <label class="labelseach">Empreendimento</label>
                <autocomplete-z ref="EmpreendimentoTypeahead"
                            placeholder="Digite um empreendimento"
                            iconClass="fas fa-user"
                            :serializer="(empreendimento) => empreendimento.nome"
                            :debounceLength="2"
                            :formField="SearchItems.empreendimentoObj"
                            v-on:search="onSearchEmpreendimento"
                            v-on:changeCode="onChangeCodeEmpreendimento"
                            :ShowCode="false"
                            />
              </div>
            </div>
            </div>
        </Forms>
    </div>
</template>

<script>
import FoldersCard from '@/views/private/realestate/commissions/components/FoldersCard/FoldersCard.js'
export default FoldersCard
</script>

<style scoped>
.margem{
  margin-bottom: 0.5rem;
}
.names-folder{
  font-size: 15px;
  width: 90%;
  height: 35px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 7px;
  cursor: pointer;

}
.names-folder-active{
  font-size: 15px;
  width: 90%;
  color: #008148;
  background-color: #E9ECEF;
  height: 35px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 7px;
  cursor: pointer;
}
.labelseach{
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: Segoe UI;
}
.labelseach-ate {
    margin-top: 10px;
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: Segoe UI;
}
.names-folder{
  font-size: 15px;
  width: 90%;
  height: 35px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 7px;
  cursor: pointer;

}
.names-folder-active{
  font-size: 15px;
  width: 90%;
  color: #008148;
  background-color: #E9ECEF;
  height: 35px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 7px;
  cursor: pointer;
}
#form-filter-folder{
  height: 60vh;
  overflow: auto;
}
.container-folders{
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.folder-item{
    margin-top: 5px;
}

.identy-1{
    margin-left: 20px;
}

.identy-2{
    margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissions/components/FoldersCard/FoldersCard.vue